import { Table } from "../../../../../components/ui/Table"
import { useSubscribers } from "../../../../../store/subscription/useSubscribers"
import {
  formatMoney
} from "../../../../../services/functions"
import { UpdatePriceForm } from "./updatePrice"
import { addMonths, format } from "date-fns"

export function SubscriptionPriceUpdate() {
  const details = useSubscribers(st => st.data.details)
  const isLoading = useSubscribers(st => st.data.isLoading)
  const queueJobs = useSubscribers(st => st.data?.details?.queueJobs || [])
  const priceAdjusts = _.filter(queueJobs, (job) => job.jobName === "Ajuste preço assinatura");

  // Aguarda o carregamento dos dados antes de renderizar
  if (isLoading || !details) {
    return (
      <div className="flex flex-col gap-6 h-full">
        <div className="flex items-center justify-center p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="ml-3 text-gray-600">Carregando informações...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-6 h-full">
      {/* Componente de reajuste de preços */}
      <div>
        <UpdatePriceForm />
      </div>

      {/* Histórico de ajustes de preço (se existir) */}
      {priceAdjusts?.length > 0 && (
        <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100%', marginBottom: '40px' }}>
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Histórico de Ajustes</h3>
          <Table.Root name='subscriptionPriceAdjustment-table'>
            <Table.Header
              columns={[
                "Data:100px",
                "Tipo:200px",
                "Status:80px",
                "Início do Reajuste:200px",
                "Valor:100px",
              ]}
            />
            <Table.Content>
              {priceAdjusts.map((jobs) => (
                <Table.Line key={jobs?.id || Math.random()}>
                  <Table.Item>{jobs?.createdAt || 'N/A'}</Table.Item>
                  <Table.Item>{jobs?.jobName || 'N/A'}</Table.Item>
                  <Table.Item>{jobs?.jobStatus || 'N/A'}</Table.Item>
                  <Table.Item>
                    {jobs?.nextBilling && !isNaN(new Date(jobs.nextBilling).getTime())
                      ? format(addMonths(new Date(jobs.nextBilling), 1), 'dd/MM/yyyy')
                      : 'N/A'}
                  </Table.Item>
                  <Table.Item>R$ {formatMoney(jobs?.adjustmentValue || 0, 2)}</Table.Item>
                </Table.Line>
              ))}
            </Table.Content>
          </Table.Root>
        </div>
      )}
    </div>
  )
}
